import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Login from "./Pages/AuthPage/Login";
import Signup from "./Pages/AuthPage/Signup";
import ForgetPassword from "./Pages/AuthPage/ForgetPassword";
import { useState } from "react";
import { Permission } from "./PermissionRoute";
import { ThemeProvider } from "./APIHelpers/ThemeContext";
import CustomerLandingPage from "./Pages/LandingPage/CustomerLandingPage";
// import MarketPlaceRoute from "./Pages/MarketTemplate/MarketPlaceRoute";
import NotFoundPage from "./Pages/NotFoundPage";
import Chatbox from "./Chatbox";
import { useApp } from "./APIHelpers/AppContext";
import AudioCallPopups from "./CallPopups/AudioCallPopups";

function App() {
  const [email, setEmail] = useState("");
  const [roleType, setRoleType] = useState("");
  const { LoginPermission, AllPermission } = Permission;
  const { openChat } = useApp(); return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route element={<LoginPermission />}>
              <Route
                path="/"
                element={
                  <Login
                    email={email}
                    setEmail={setEmail}
                    roleType={roleType}
                    setRoleType={setRoleType}
                  />
                }
              />
              <Route
                path="/login"
                element={
                  <Login
                    email={email}
                    setEmail={setEmail}
                    roleType={roleType}
                    setRoleType={setRoleType}
                  />
                }
              />
              <Route
                path="/signup"
                element={
                  <Signup
                    email={email}
                    setEmail={setEmail}
                    roleType={roleType}
                    setRoleType={setRoleType}
                  />
                }
              />
              <Route
                path="/signup/:token"
                element={
                  <Signup
                    email={email}
                    setEmail={setEmail}
                    roleType={roleType}
                    setRoleType={setRoleType}
                  />
                }
              />
              <Route path="/forget-password" element={<ForgetPassword />} />
              {/* <Route
                path="/store/:storeName/:pageId"
                element={<MarketPlaceRoute />}
              /> */}
            </Route>
            <Route path="/page/:id" element={<CustomerLandingPage />} />
            <Route element={<AllPermission />}>
              <Route path="/home" element={<Dashboard />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </div>
      {openChat &&
        <div className="position-fixed bottom-0 z-2 end-0">
          <div className="hstack gap-2 align-items-end">
            <Chatbox />
          </div>
        </div>
      }
    </ThemeProvider>
  );
}

export default App;
